import { IReportDescription } from '@valhalla/data/entities';
import { Observable } from 'rxjs';

export abstract class ReportsDataHttpService {
	abstract getReports(criteria?: IGetReportsCriteria): Observable<IGetReportsResult>;
}

export interface IGetReportsCriteria {
	contextType?: number;
}

export interface IGetReportsResult {
	reports: Array<IReportDescription>;
}
